import React, { useEffect } from 'react';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { AboutSection } from './components/AboutSection';
import { CreatorsSection } from './components/CreatorsSection';
import { CommunitySection } from './components/CommunitySection';
import { EventDetailsSection } from './components/EventDetailsSection';
import { TicketsSection } from './components/TicketsSection';
import { Footer } from './components/Footer';
import { ScrollProgress } from './components/ScrollProgress';
import { ImmersiveExperienceSection } from './components/ImmersiveExperienceSection';
import { InteractionSection } from './components/InteractionSection';
import { CulinarySection } from './components/CulinarySection';
import { CreditsSection } from './components/CreditsSection';
import { BringToYourCitySection } from './components/BringToYourCitySection';
import { HouseOfLionsSection } from './components/HouseOfLionsSection';
import { SikhHeritageForwardCTA } from './components/SikhHeritageForwardCTA';
import { SchoolsHighlightSection } from './components/SchoolsHighlightSection';
import { AIEntrepreneurshipHighlightSection } from './components/AIEntrepreneurshipHighlightSection';
import { LanguageProvider } from './context/LanguageContext';
export function App() {
  useEffect(() => {
    // Add a class to the body for global styling
    document.body.classList.add('bg-black', 'text-white', 'overflow-x-hidden');
    // Cleanup function
    return () => {
      document.body.classList.remove('bg-black', 'text-white', 'overflow-x-hidden');
    };
  }, []);
  return <LanguageProvider data-id="element-0" data-mp="38kgkucl9nspi">
      <div className="relative" data-id="element-1" data-mp="38o4fjf2g6l5t">
        <ScrollProgress data-id="element-2" data-mp="3dl4n5uey3vz1" />
        <Navbar data-id="element-3" data-mp="3dlnwimqj5c1g" />
        <main className="w-full" data-id="element-4" data-mp="3dm5zs3bm0qiv">
          <HeroSection data-id="element-5" data-mp="nvsup6ui4rx0" />
          <AboutSection data-id="element-6" data-mp="nwc582htoe10" />
          <ImmersiveExperienceSection data-id="element-7" data-mp="nv0wrpdfmi3k" />
          <InteractionSection data-id="element-8" data-mp="sunb624zy4dy" />
          <CulinarySection data-id="element-9" data-mp="stkmm0v5ce17" />
          <HouseOfLionsSection data-id="element-10" data-mp="ssspumptca9c" />
          <CreatorsSection data-id="element-11" data-mp="36hv93iy4lzn" />
          <CommunitySection data-id="element-12" data-mp="35ox2qy1z4t4" />
          <SikhHeritageForwardCTA data-id="element-13" data-mp="34x31kk3tf4y" />
          <SchoolsHighlightSection data-id="element-14" data-mp="3uct4hmy40t22" />
          <AIEntrepreneurshipHighlightSection data-id="element-15" data-mp="3ubrfeek9e61c" />
          <EventDetailsSection data-id="element-16" data-mp="3uevuw836co7b" />
          <TicketsSection data-id="element-17" data-mp="d57h17dyqql6" />
          <BringToYourCitySection data-id="element-18" data-mp="d3cuxpqygsfi" />
          <CreditsSection data-id="element-19" data-mp="d2l6cyvrzuyq" />
        </main>
        <Footer data-id="element-20" data-mp="85bb32lpgp2z" />
      </div>
    </LanguageProvider>;
}